import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

export const ManualTotalForm_ResolvableServiceValue_Fragment = graphql(`
  fragment ManualTotalForm_ResolvableServiceValue_Fragment on ResolvableServiceValue {
    _id
    priceExcludingVat {
      __typename
      value {
        __typename
        mode
        resolverId
        value
      }
      currencyId {
        __typename
        mode
        resolverId
        value
      }
      ...ResolvableAmountCmp_ResolvableAmount_Fragment
    }
    discountPercentage {
      __typename
      mode
      resolverId
      value
      ...ResolvablePercentCmp_ResolvablePercent_Fragment
    }
    discountAmount {
      __typename
      value {
        __typename
        mode
        resolverId
        value
      }
      currencyId {
        __typename
        mode
        resolverId
        value
      }
      ...ResolvableAmountCmp_ResolvableAmount_Fragment
    }
    vatId {
      __typename
      mode
      resolverId
      value
      ...ResolvableIdCmp_ResolvableId_Fragment
    }
  }
`);

export type ManualTotalForm_ResolvableServiceValue = ResultOf<
  typeof ManualTotalForm_ResolvableServiceValue_Fragment
>;
